'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bananaContext = require('./banana-context');

var _bananaContext2 = _interopRequireDefault(_bananaContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// @see https://github.com/yahoo/react-intl/blob/v2.4.0/src/components/message.js
var Message = function Message(_ref) {
	var id = _ref.id,
	    _ref$placeholders = _ref.placeholders,
	    placeholders = _ref$placeholders === undefined ? [] : _ref$placeholders;
	return (0, _react.createElement)(_bananaContext2.default.Consumer, null, function (banana) {
		if (!placeholders.length) {
			return banana.i18n(id);
		}

		// If all of the placeholders are not react elements, return the string.
		if (!placeholders.filter(function (p) {
			return (0, _react.isValidElement)(p);
		}).length) {
			return banana.i18n.apply(banana, [id].concat(_toConsumableArray(placeholders)));
		}

		var uid = Math.floor(Math.random() * 0x10000000000).toString(16);
		var tokenDelimiter = '@__' + uid + '__@';
		var elements = [];

		// Iterates over the `props` to keep track of any React Element
		// values so they can be represented by the `token` as a placeholder
		// when the `message` is formatted. This allows the formatted
		// message to then be broken-up into parts with references to the
		// React Elements inserted back in.
		var tokenizedPlaceholders = placeholders.map(function (placeholder, index) {
			if ((0, _react.isValidElement)(placeholder)) {
				var token = 'ELEMENT-' + uid + '-' + index;
				elements = _extends({}, elements, _defineProperty({}, token, placeholder));
				return tokenDelimiter + token + tokenDelimiter;
			}

			return placeholder;
		});

		var message = banana.i18n.apply(banana, [id].concat(_toConsumableArray(tokenizedPlaceholders)));

		// Split the message into parts so the React Element values captured
		// above can be inserted back into the rendered message. This
		// approach allows messages to render with React Elements while
		// keeping React's virtual diffing working properly.
		var nodes = message.split(tokenDelimiter).filter(function (part) {
			return !!part;
		}).map(function (part) {
			return elements[part] || part;
		});

		// Needs to use `createElement()` instead of JSX, otherwise React will
		// warn about a missing `key` prop with rich-text message formatting.
		return _react.createElement.apply(undefined, [_react.Fragment, null].concat(_toConsumableArray(nodes)));
	});
};

Message.propTypes = {
	id: _propTypes2.default.string.isRequired,
	placeholders: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.element]))
};

Message.defaultProps = {
	placeholders: []
};

exports.default = Message;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@wikimedia/react.i18n/dist/message.js
// module id = 500
// module chunks = 0